<div
  class="relative select-none flex items-center"
  (mouseenter)="!isCopied() && showTooltip()"
  (mouseleave)="hideTooltip()">
  <button
    class="flex items-center justify-center rounded-md p-sm"
    [class.bg-primary-50]="!isCopied()"
    [class.bg-success-50]="isCopied()"
    [class.cursor-default!]="isCopied()"
    (click)="!isCopied() && copyLink()">
    <div
      class="overflow-hidden transition-all duration-500"
      [class.max-w-6]="!isCopied()"
      [class.max-w-0]="isCopied()">
      <div
        class="transition-all duration-500"
        [class.translate-y-0]="!isCopied()"
        [class.-translate-y-4]="isCopied()">
        <lib-link-icon iconClass="text-primary-500 size-6"></lib-link-icon>
      </div>
    </div>

    <div
      class="flex items-center overflow-hidden transition-all duration-500"
      [class.max-w-0]="!isCopied()"
      [class.max-w-48]="isCopied()">
      <div
        class="flex items-center transition-all duration-500"
        [class.translate-y-4]="!isCopied()"
        [class.translate-y-0]="isCopied()">
        <lib-check-icon
          iconClass="size-6 text-success-500 p-1 do-not-transform" />
        <span class="text-sm font-medium text-success-500 whitespace-nowrap">
          {{ 'copy_url_copied_label' | transloco }}
        </span>
      </div>
    </div>
  </button>
</div>

@if (tooltipVisible() && !isCopied()) {
  <div
    class="fixed -translate-x-1/2 -translate-y-full whitespace-nowrap p-md rounded-lg bg-white shadow-md text-neutral-900 text-xs font-medium pointer-events-none"
    [style.top]="tooltipStyle().top"
    [style.left]="tooltipStyle().left">
    {{ 'copy_url_button_tool_tip_label' | transloco }}
    <span
      class="absolute top-full left-1/2 -translate-x-1/2 border-6 border-transparent border-t-white"></span>
  </div>
}
